import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLoaderData } from "react-router-dom";
import { general } from "helpers/sharedJsHelpers";
import { createRequiredAsteriskController } from 'shared/requiredAsteriskObserver';

import 'shared/ua-widget.js';

const { waitForElement } = general;


export default function LoginRegisterBox({ allTrial, setUserInitialized }) {
  const state = useLoaderData();
  const { cart, user } = state;

  const [login, setLogin] = useState(false);
  const requiredAsteriskController = createRequiredAsteriskController({
    observerKey: '__checkoutRequiredAsteriskObserverReact',
    modeToggleHandlerKey: '__checkoutRequiredAsteriskModeToggleHandlerReact'
  });

  const setUaRegisterSubmitStatus = (profession, specialtyReq, specialtyVal, schoolReq, schoolVal) => {
    const uaRegSubmit = document.querySelector('ua-user-register .ua-submit');
    if (profession.trim().length && (!specialtyReq || specialtyVal.trim().length) && (!schoolReq || schoolVal.trim().length)) {
      uaRegSubmit.removeAttribute("disabled");
    } else {
      uaRegSubmit.setAttribute("disabled", "disabled");
    }
  };


  function startCheckoutRequiredAsteriskObserver() {
    requiredAsteriskController.start();
  }

  function stopCheckoutRequiredAsteriskObserver() {
    requiredAsteriskController.stop();
  }

  const changeUALoginFormText = () => {
    if (login === false) setLogin(true);
    stopCheckoutRequiredAsteriskObserver();
    waitForElement("#uaUserLoginForm").then(function() {
      $("#ua-username").attr('placeholder', 'Email');
      $("#ua-password").attr('placeholder', 'Password');
      $("label[for='remember-cb']").text('Remember me');
      $(".ua-username-label > span").text('Email');
      $(".ua-reset-link").text('Forgot your password?');
      $(".ua-submit").text(`Login & Continue${allTrial ? '' : ' to Payment'}`);
      $(".ua-create-user-btn").text('(Register for new account)');
      return true;
    }).catch(() => {
      console.warn("#uaUserLoginForm element not loaded");
    });
  };

  const changeUARegisterFormText = () => {
    if (login === true) setLogin(false);
    waitForElement("#uaUserRegisterForm").then(function() {
      $(".create-acc-heading").text('Register');
      $("#ua-firstname").attr('placeholder', 'First Name');
      $("#ua-lastname").attr('placeholder', 'Last Name');
      $("#ua-register-username").attr('placeholder', 'Username');
      $("#ua-register-email").attr('placeholder', 'Email');
      $("#ua-register-password").attr('placeholder', 'Password');
      $("#ua-password-confirm").attr('placeholder', 'Re-enter your password');
      $(".ua-submit").text(`Register & Continue${allTrial ? '' : ' to Payment'}`);
      $(".ua-existing-user-btn").text('(Already have an account? Log in)');
      // Inject extra registration fields into widget
      const extraRegistrationFields = $('.bv-user-reg-profession-field');
      if (!$('.bv-user-reg-profession-field').is(':visible')) {
        extraRegistrationFields.insertAfter('.ua-password-confirm-group');
      }
      startCheckoutRequiredAsteriskObserver();
      return true;
    }).catch(() => {
      console.warn("#uaUserRegisterForm element not loaded");
    });
  };

  const setSubmit = () => {
    const professionElt = document.querySelector('#user_user_type');
    const specialtyElt = document.querySelector('#user_sub_user_type');
    const schoolElt = document.querySelector('#user_school');
    setUaRegisterSubmitStatus(professionElt.value, specialtyElt.required, specialtyElt.value, schoolElt.required, schoolElt.value);
  };

  const syncBvSession = (token, saveUserInBv, profession, specialty, school, year, month) => {
    const bvSessionApiUrl = document.getElementById('bv_session_api_url').value;
    // Add site-loading class to show loading modal
    $("body").removeClass('site-loaded').addClass('site-loading');
    $.post(bvSessionApiUrl, {
      user: {
        ua_auth_token: token,
        save_user: saveUserInBv,
        profession: profession,
        specialty: specialty,
        school: school,
        'graduation_date(1i)': year,
        'graduation_date(2i)': month,
        sign_up_referrer_url: window.location.href
      }
    }).then(async function(response) {
      try {
        if (cart.containsOnlyTrialItems()) {
          window.location.replace('/subscriptions/activate-trials');
        } else {
          await user.handleInit(cart, saveUserInBv);
          setUserInitialized(true);
          $("body").removeClass('site-loading').addClass('site-loaded');
        }
      } catch (err) {
        console.error('Error in syncBvSession then handler:', err);
        $("body").removeClass('site-loading').addClass('site-loaded');
      }
      return true;
    }).catch(function(error) {
      console.error('syncBvSession error:', error);
      $("body").removeClass('site-loading').addClass('site-loaded');
      if (error?.responseJSON?.errors?.[0]?.details === 'User deactivated') {
        window.sessionStorage.setItem("user_deactivated", 'true');
        window.location.reload();
      }
    });
  };

  const loadUAEventHandlers = () => {
    waitForElement("ua-ng-login").then(function() {
      requiredAsteriskController.sync(!login);
      requiredAsteriskController.bindModeToggleHandler(() => {
        const registerForm = document.querySelector('#uaUserRegisterForm');
        requiredAsteriskController.sync(!!registerForm && registerForm.offsetParent !== null);
      });
      let saveUserInBv = false;
      const uaLogin = document.querySelector('ua-ng-login');
      let profession = '';
      let specialty = '';
      let school = '';
      let year = '';
      let month = '';
      // Disable register submit by default
      setUaRegisterSubmitStatus(profession, false, specialty, false, school);

      document.querySelector('#user_user_type').addEventListener('change', function(_evt) { setSubmit(); });
      document.querySelector('#user_sub_user_type').addEventListener('change', function(_evt) { setSubmit(); });
      document.querySelector('#user_school').addEventListener('change', function(_evt) { setSubmit(); });

      uaLogin.addEventListener('loginEvent', function () {
        const token = document.getElementById('user_login_token').value;
        syncBvSession(token, saveUserInBv, profession, specialty, school, year, month);
      });
      uaLogin.addEventListener('logoutEvent', function () {
      });
      uaLogin.addEventListener('registerEvent', function () {
        saveUserInBv = true;
        profession = document.querySelector('#user_user_type').value;
        specialty = document.querySelector('#user_sub_user_type').value;
        school = document.querySelector('#user_school').value;
        year = document.querySelector('#user_graduation_date_1i').value;
        month = document.querySelector('#user_graduation_date_2i').value;
      });
      uaLogin.addEventListener('resetEvent', function () {
      });
      return true;
    }).catch(() => {
      console.warn("ua-ng-login element not loaded");
    });
  };

  if (login) {
    changeUALoginFormText(this);
    $(document).on('click', '.ua-create-user-btn', () => changeUARegisterFormText(this));
  } else {
    changeUARegisterFormText(this);
    $(document).on('click', '.ua-existing-user-btn', () => changeUALoginFormText(this));
  }
  loadUAEventHandlers(this);

  return (
    <>
      <div className="ua-widget-checkout">
        { login ? (
          <ua-widget data-widget-root="login" />
        ) : (
          <ua-widget data-widget-root="register" />
        )}
        <div className="row-last">Last step: Payment</div>
      </div>
    </>
  );
}

LoginRegisterBox.propTypes = {
  allTrial: PropTypes.bool,
  setUserInitialized: PropTypes.func
};
